var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { colors, shadows } from "@wrstudios/theme";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-height: 23.7rem;\n  padding: 1.2rem;\n  border-radius: 0.6rem;\n  box-shadow: ", ";\n  background-color: ", ";\n  overflow: auto;\n\n  &:after {\n    content: \"\";\n    border: 0.8rem solid transparent;\n    border-top-color: ", ";\n    transform: translate(-50%, 100%);\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n  }\n"], ["\n  width: 100%;\n  max-height: 23.7rem;\n  padding: 1.2rem;\n  border-radius: 0.6rem;\n  box-shadow: ", ";\n  background-color: ", ";\n  overflow: auto;\n\n  &:after {\n    content: \"\";\n    border: 0.8rem solid transparent;\n    border-top-color: ", ";\n    transform: translate(-50%, 100%);\n    position: absolute;\n    left: 50%;\n    bottom: 0;\n  }\n"])), shadows.overlay, colors.white, colors.white);
var templateObject_1;